import { render, staticRenderFns } from "./notificationsConfirmDialog.vue?vue&type=template&id=d1b9c2bc"
import script from "./notificationsConfirmDialog.vue?vue&type=script&lang=js"
export * from "./notificationsConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports